"use strict";

/*
 * Reads browser cookies. This is the one shared home for cookie access on the frontend, so a
 * module never parses document.cookie itself.
 */
const cookieService = (() => {
    /**
     * Returns the value of a cookie by name.
     * @param {string} name - The cookie name.
     * @returns {string|undefined} The cookie value, or undefined when it is not set.
     */
    const getCookie = (name) => {
        const parts = `; ${document.cookie}`.split(`; ${name}=`);

        if (parts.length === 2) {
            return parts.pop().split(";").shift();
        }

        return undefined;
    };

    return {
        getCookie
    };
})();

export default cookieService;
